__turbopack_context__.v({
  "container": "styles-module-scss-module__WCW6Oq__container",
});
